export default __webpack_public_path__ + "static/grow-e0cbb8df9a7c11ee5e5d011efecc09ae.jpg";